module.exports = __webpack_public_path__ + "img/profile.a7399168.svg";